<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2023-11-22 13:28:52
 * @LastEditors: hexy
 * @LastEditTime: 2024-01-02 13:27:47
 * @Description: 协作单位
 * @FilePath: \ICPSxin\src\views\platform\ICPS\GHnumber\components\cooperativeUnit.vue
-->
<template>
  <div>
    <el-dialog v-dialogDrag :visible.sync="cooperDialog" width="1080px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">协作单位设置</span>
      <div style="margin-bottom: 10px">
        <span>主合同单位名称:{{ unitParma.supplierName }}</span>
        <span style="margin-left: 30px">供应商类别:{{ unitParma.supplierType }}</span>
      </div>
      <div style="margin-bottom: 10px">
        <el-button class="bottom_one" @click="addUnit()">添 加</el-button>
      </div>
      <div class="dialogOtherinfo">
        <el-table ref="table11Refs" height="400" :header-cell-style="{ background: '#f3f6f9' }"
          :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="formDateUnit.unitList"
          tooltip-effect="dark" highlight-current-row>
          <el-table-column prop="collaborativeUnitId" label="公司名称" width="160px" align="center">
            <template slot-scope="scope">
              <el-select ref="collaborativeUnit" v-model="scope.row.collaborativeUnitId" style="width: 100%"
                placeholder="请选择">
                <el-option v-for="(item, index) in cooperUnitList" :key="index" :label="item.name" :value="item.id"
                  @click.native="setLabel(item, scope.$index)"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="站点" width="200px" align="center">
            <template slot-scope="scope">
              <el-select :ref="`stationId${scope.$index}`" :key="scope.$index" v-model="scope.row.chooseStationList"
                multiple style="width: 100%" placeholder="请选择" @change="setStationList(scope.$index)">
                <el-option v-for="(item, index) in stationLabelList" :key="index" :label="item.name"
                  :value="item.id"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="collaborativeContractNumber" label="协作合同编码" width="150px" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.collaborativeContractNumber" style="width: 100%" placeholder="请输入" />
            </template>
          </el-table-column>
          <el-table-column prop="shareContractCode" label="共享合同编码" width="150px" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.shareContractCode" style="width: 100%" placeholder="请输入" />
            </template>
          </el-table-column>
          <el-table-column prop="shareSupplierName" label="明细供应商编码" width="150px" align="center">
            <template slot-scope="scope">
              <el-link v-if="!scope.row.shareSupplierName" :underline="false" type="success"
                    @click="openSupplyDetail(scope.$index)">请选择</el-link>
                  <el-link v-else :underline="false" type="success" @click="openSupplyDetail(scope.$index)">{{
                    scope.row.shareSupplierName }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="shareProjectName" label="项目" width="150px" align="center">
            <template slot-scope="scope">
              <el-link v-if="!scope.row.shareProjectName" :underline="false" type="success"
                    @click="openProject(scope.$index)">请选择</el-link>
                  <el-link v-else :underline="false" type="success" @click="openProject(scope.$index)">{{
                    scope.row.shareProjectName }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="collaborativeUnitTaxRate" label="税率" width="100px" align="center"></el-table-column>
          <el-table-column prop="annex" label="附件" width="200px" align="center">
            <template slot-scope="scope">
              <span>
                <FileComponent :key="scope.$index" fileCode="contractFile" :files="scope.row.annexArr"
                  @deleteFile="deleteFile($event, scope.$index)" @uplodeSuccess="uplodeSuccess($event, scope.$index)" />
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="createUserName" label="发票收取约定" width="auto" align="center">
            <template slot-scope="scope">
              <div><el-link :underline="false" type="success" class="table_link" @click="setUnit(scope.row)">设置</el-link>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="操作" width="auto" align="center">
            <template slot-scope="scope">
              <el-link :underline="false" type="danger" class="table_link" @click="deleUnit(scope.row, scope.$index)"> 删除
              </el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_one" @click="cooperDialog = false">取消</el-button>
        <el-button class="bottom_all_two" @click="saveUnit()">确定</el-button>
      </span>
    </el-dialog>
    <!-- 发票收取约定 -->
    <el-dialog v-dialogDrag :visible.sync="addInvoiceDialog" width="600px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">发票收取约定</span>
      <div style="margin-bottom: 10px">
        <el-button class="bottom_one" @click="addInvoice()">添 加</el-button>
      </div>
      <div class="dialogOtherinfo">
        <el-table ref="table11Refs" height="400" :header-cell-style="{ background: '#f3f6f9' }"
          :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="formDate.accountList"
          tooltip-effect="dark" highlight-current-row>
          <el-table-column prop="account" label="收款账号" width="150px" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.account" style="width: 100%" placeholder="请输入" />
            </template>
          </el-table-column>
          <el-table-column prop="interbankNumber" label="联行号" width="150px" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.interbankNumber" style="width: 100%" placeholder="请输入" />
            </template>
          </el-table-column>
          <el-table-column prop="billFormId" label="票据形式" width="160px" align="center">
            <template slot-scope="scope">
              <el-select ref="billForm" v-model="scope.row.billFormId" style="width: 100%" placeholder="请选择"
                :disabled="isEnable" @change="
                  $nextTick(() => {
                    scope.row.billForm = $refs.billForm.selectedLabel;
                  })">
                <el-option v-for="(item, index) in billList" :key="index" :label="item.itemName"
                  :value="item.id"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="操作" width="auto" align="center">
            <template slot-scope="scope">
              <el-link :underline="false" type="danger" class="table_link" @click="deleInvoice(scope.$index)"> 删除
              </el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_one" @click="addInvoiceDialog = false">取消</el-button>
        <el-button class="bottom_all_two" @click="saveInvoice()">确定</el-button>
      </span>
    </el-dialog>
    <!-- 项目 -->
    <ProjectTable ref="projectTable" :dialog.sync="projectDia" @resetProject="resetProject" @setProject="setProject" />
    <!-- 明细客商 -->
    <detailSupply ref="detailSupply" :dialog.sync="detailSupplyDialog" :detailRow="low" saveType="2" :isCustomer="true"
      @reset="resetSupply" @setDetail="setDetail" />
  </div>
</template>
<script>
import mixin from "@/mixins/ICPSmixin.js";
import { getUserAutList, getDicType } from "@/api/common.js";
import { queryList, queryCollaborativeUnitBySuppler, queryAccountList, saveAccount, saveUnit } from "@/api/GHnumber/cooperativeUnit";
import { getToken, getUserId } from "@/utils/auth";
import FileComponent from "@/components/File/fileComponent";
import ProjectTable from "@/views/platform/ICPS/Wise/docking/accountingSheet/report/ProjectTable.vue";
import detailSupply from "@/views/ShareSystem/components/contract/detailSupply";
export default {
  mixins: [mixin],
  components: { FileComponent,ProjectTable,detailSupply },
  data() {
    return {
      cooperDialog: false,
      unitParma: {},
      addInvoiceDialog: false,
      isEnable: false,
      deleteData: [],
      formDateUnit: {
        contractId: "",
        supplierId: "",
        supplierName: "",
        unitList: [],
      },
      formDate: {
        collaborativeUnitId: "",
        accountList: [],
      },
      cooperUnitList: [], //协作单位
      stationLabelList: [], //站点
      chooseStationList: [], //站点
      billList: [], //票据形式
      modifyPage: {
        supplierId: "",
        contractId: "",
      },
      loading: false,
      upheader: {
        "access-token": getToken(),
        "user-id": getUserId(),
      },
      files: [],
      projectDia:false,
      lowIndex:"",
      detailSupplyDialog:false,
    };
  },
  async created() {
    getDicType({ code: "SHOUKUANXINGSHI" }).then(res => {
      if (res.code === 1001) {
        this.billList = res.data.items;
      }
    });
    this.stationLabelList = await getUserAutList(true);
  },
  methods: {
    setDetail(param) {
      this.$set(this.formDateUnit.unitList[this.lowIndex], 'shareSupplierCode', param.profitCenterCode);
      this.$set(this.formDateUnit.unitList[this.lowIndex], 'shareSupplierName', param.profitCenterName);
      this.resetSupply();
    },
    openSupplyDetail(index) {
      this.lowIndex = index
      this.detailSupplyDialog = true
    },
    resetSupply() {
      this.detailSupplyDialog = false
    },
    setProject(row) {
      this.$nextTick(() => {
        this.$set(this.formDateUnit.unitList[this.lowIndex],'shareProjectCode',row.code)
        this.$set(this.formDateUnit.unitList[this.lowIndex],'shareProjectName',row.name)
        console.log(this.formDateUnit.unitList)
      })
    },
    openProject(index) {
      this.lowIndex = index
      this.projectDia = true
    },
    resetProject() {
      this.projectDia = false
    },
    setCooperative(val) {
      if (val) {
        this.unitParma = val;
        this.modifyPage.contractId = val.id;
        this.modifyPage.supplierId = val.supplierId;
        this.formDateUnit.supplierId = val.supplierId;
        this.formDateUnit.supplierName = val.supplierName;
        this.formDateUnit.contractId = val.id;
        this.getUnitList();
      }
      this.cooperDialog = true;
      this.getCooperUnit();
    },
    getUnitList() {
      var param = {
        supplierId: "",
      };
      param.supplierId = this.unitParma.supplierId;
      queryCollaborativeUnitBySuppler(param).then(res => {
        this.cooperUnitList = res.data;
      });
    },
    addUnit() {
      var param = {
        annex: "", //附件url
        annexArr: [],
        collaborativeContractNumber: "", //协作单位编号
        collaborativeUnit: "", //协作单位名称
        collaborativeUnitId: "",
        collaborativeUnitTaxRate: "", //协作单位税率
        shareProjectCode: "",
        shareProjectName: "",
        shareContractCode: "",
        shareSupplierName: "",
        shareSupplierCode: "",
        stationList: [],
        status: 1, //修改新增为1，删除为0
      };
      this.formDateUnit.unitList.push(param);
    },
    addInvoice() {
      var param = {
        id: "",
        account: "", //协作单位编号
        interbankNumber: "", //协作单位名称
        billFormId: "",
        billForm: "", //协作单位税率
      };
      this.formDate.accountList.push(param);
    },
    getCooperUnit() {
      this.deleteData = [];
      queryList(this.modifyPage).then(res => {
        if (res.data) {
          this.formDateUnit.unitList = res.data;
          this.formDateUnit.unitList.forEach(item => {
            item.annexArr = item.annex ? JSON.parse(item.annex) : [];
            item.chooseStationList = item.stationList.map(station => station.stationId);
          });
          //   res.data.map(item => {
          //     this.chooseStationList = item.stationList.map(station => station.stationId);
          //     return item;
          //   });
        } else {
          this.formDateUnit.unitList = [];
        }
      });
    },
    setUnit(row) {
      this.addInvoiceDialog = true;
      this.formDate.collaborativeUnitId = row.collaborativeUnitId;
      queryAccountList({ collaborativeUnitId: row.collaborativeUnitId }).then(res => {
        if (res.data.length > 0) {
          this.formDate.accountList = res.data;
        } else {
          this.formDate.accountList = [];
        }
      });
    },
    deleUnit(item, index) {
      this.formDateUnit.unitList.splice(index, 1);
      this.deleteData.push(item);
      this.deleteData.forEach(res => {
        res.status = 0; //0是删除
      });
    },
    deleInvoice(index) {
      this.formDate.accountList.splice(index, 1);
    },
    setLabel(item, index) {
      this.$nextTick(() => {
        this.$set(this.formDateUnit.unitList[index], "collaborativeUnit", item.name);
        this.$set(this.formDateUnit.unitList[index], "collaborativeUnitTaxRate", item.taxRate);
        if (item.name == this.unitParma.supplierName) {
          this.$set(this.formDateUnit.unitList[index], "collaborativeContractNumber", this.unitParma.contractNumber);
        }
        console.log(this.unitParma)
        // this.$set(this.formDateUnit.unitList[index], "collaborativeContractNumber", item.cooperationNumber);
      });
    },
    setStationList(index) {
      this.$forceUpdate();
      this.$nextTick(() => {
        let station = this.$refs[`stationId${index}`].selected;
        var arrList = [];
        station.forEach(item => {
          arrList.push({
            stationId: item.value,
            stationName: item.label,
          });
        });
        this.$set(this.formDateUnit.unitList[index], "stationList", arrList);
      });
    },
    saveUnit() {
      this.formDateUnit.unitList.forEach(item => {
        item.annex = JSON.stringify(item.annexArr);
      });
      console.log(this.formDateUnit.unitList);
      let formDateUnit = JSON.parse(JSON.stringify(this.formDateUnit));
      formDateUnit.unitList = formDateUnit.unitList.concat(this.deleteData);
      saveUnit(formDateUnit).then(res => {
        if (res.code == 1001) {
          this.$message.success("操作成功");
          this.cooperDialog = false;
        }
      });
    },
    saveInvoice() {
      saveAccount(this.formDate).then(res => {
        if (res.code == 1001) {
          this.$message.success("操作成功");
          this.addInvoiceDialog = false;
        }
      });
    },
    /**
     * @Description: 删除附件
     * @Param:
     * @Author: wangwangwang
     */
    deleteFile(index, scopeIndex) {
      console.log(index, scopeIndex);
      let files = JSON.parse(JSON.stringify(this.formDateUnit.unitList[scopeIndex].annexArr));
      files.splice(index, 1);
      // this.formDateUnit.unitList[].annex.splice(index, 1);
      this.$nextTick(() => {
        this.$set(this.formDateUnit.unitList[scopeIndex], "annexArr", files);
        this.$forceUpdate();
      });
    },
    /**
     * @Description: 上传成功
     * @Param:
     * @Author: wangwangwang
     */
    uplodeSuccess(data, scopeIndex) {
      console.log(data);
      let item = [
        {
          name: data.fileName,
          fileName: data.fileName,
          fileUrl: data.fileUrl,
          path: data.fileUrl,
          fileType: 1,
          type: 1,
          createTime: new Date().Format("yyyy-MM-dd hh:mm:ss"),
        },
      ];
      this.$nextTick(() => {
        this.$set(this.formDateUnit.unitList[scopeIndex], "annexArr", item);
        this.$forceUpdate();
      });
    },
  },
};
</script>
